<template>
  <div>
    <iframe id="myframe" @load="loaded" ref="myframe" :src="url"></iframe>
  </div>
</template>

<script>
export default {
  props: ["CesiumData"],
  name: "index",
  data() {
    return {
      url: process.env.VUE_APP_SUPER_MAP,
    };
  },
  watch: {
    CesiumData: {
      handler() {},
      deep: true, // 深度监听父组件传过来对象变化
    },
  },
  mounted() {
    window.addEventListener(
      "message",
      (e) => {
        this.$emit("lnglat", e.data);
      },
      false
    );
  },
  methods: {
    loaded() {
      // 区划数组数据转换
      let points = [];
      if (this.CesiumData.points) {
        JSON.parse(this.CesiumData.points).forEach((key) => {
          points.push(key.lon, key.lat);
        });
      } else {
        points = [];
      }
      // 点位扎点数据转换
      let loglat = [];
      if (this.CesiumData.loglat) {
        loglat = this.CesiumData.loglat.split(",");
      } else {
        loglat = [];
      }
      let CesiumData = {
        clickMarkerShow: this.CesiumData.clickMarkerShow,
        loglat: loglat,
        points: points,
        type: this.CesiumData.type,
      };
      this.$refs.myframe.contentWindow.postMessage(
        {
          type: "myData",
          data: CesiumData,
        },
        "*"
      );
    },
  },
};
</script>
<style>
#myframe {
  padding: 1%;
  width: 98%;
  height: 50vh;
}
</style>
